import { useIsMounted } from 'core/ui-next';
import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number | null) {

	const savedCallback = useRef<() => void>(null);
	const isMounted = useIsMounted();

	useEffect(() => {
		savedCallback.current = callback;
	}, [callback]);

	useEffect(() => {

		if (delay === null) return;

		const tick = () => {
			if (savedCallback.current && isMounted()) {
				savedCallback.current();
			}
		};

		const id = setInterval(tick, delay);
		return () => clearInterval(id);
	}, [delay, isMounted]);
}
